import { createContext } from "react";

interface ITableContext {
  onGenerateCurrentState: () => void;
}

export const TableContext = createContext<ITableContext>({
  onGenerateCurrentState: () => {},
});
